function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B94DB5D0-B6B0-4181-9218-6E55F588B8BD");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pers\\xF6nliche-Angaben-03-Geschlecht",
  transform: "translate(-586.000000, -536.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Frage",
  transform: "translate(568.000000, 384.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Card-Antwort-2",
  transform: "translate(0.000000, 134.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0632329,9.88653235 L17.1638538,6.78311251 M14.6848644,6.17180735 L17.7746077,6.17180735 M17.8283476,9.34558762 L17.8283476,6.25305538 M10.6346151,18 C13.1942423,18 15.2692302,15.9231391 15.2692302,13.3612014 C15.2692302,10.7992637 13.1942423,8.72240286 10.6346151,8.72240286 C8.07498786,8.72240286 6,10.7992637 6,13.3612014 C6,15.9231391 8.07498786,18 10.6346151,18 Z",
  id: "Combined-Shape",
  stroke: "#FFFFFF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}))))));

var SvgMannlich = function SvgMannlich(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMannlich, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mannlich.0d68a317.svg";
export { ForwardRef as ReactComponent };